<template>
    <div>
      <!-- Form Group -->
      <div class="form-group mb-3">
        <label for="subject" class="form-label">
          <i class="bi bi-book"></i> Subject
        </label>
        <input
          type="text"
          id="subject"
          v-model="subject"
          class="form-control"
          placeholder="Enter Subject Name"
          required
        />
        <div v-if="errorMessage" class="alert alert-danger mt-2">
          <i class="bi bi-exclamation-circle-fill"></i> {{ errorMessage }}
        </div>
        <div v-if="successMessage" class="alert alert-success mt-2">
          <i class="bi bi-check-circle-fill"></i> {{ successMessage }}
        </div>
        <button @click="submitForm" class="btn btn-primary mt-3">
          <i class="bi bi-save"></i> Save
        </button>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        subject: '',
        successMessage: null,
        errorMessage: null,
      };
    },
    methods: {
      async submitForm() {
        this.successMessage = null; // Reset success message
        this.errorMessage = null;   // Reset error message
  
        try {
          const response = await axios.post('/insert-subject', {
            subject: this.subject
          }, {
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            }
          });
  
          // Handle successful submission
          this.successMessage = response.data.message; // Set the success message
          this.subject = ''; // Clear the form
        } catch (error) {
          if (error.response && error.response.data) {
            // Handle errors from Laravel
            this.errorMessage = error.response.data.message || 'An error occurred.';
          } else {
            this.errorMessage = 'An error occurred.';
          }
        }
      }
    }
  };
  </script>
  
  <style scoped>
  /* Add any specific styles you need */
  </style>
  